import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-out-app',
  templateUrl: './layout-out-app.component.html',
  styleUrls: ['./layout-out-app.component.scss'],
})
export class LayoutOutAppComponent {}
